module.exports = __webpack_public_path__ + "static/img/about3.2383880.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/about3.png
// module id = dtw1
// module chunks = 0